import { collection, getDocs, query, runTransaction, where } from 'firebase/firestore';
import { db } from '@/firebase';
import { getTenantCollectionPath } from '../utils/firebase';

async function updateBrandInProducts(id, brandData) {
	await runTransaction(db, async (transaction) => {
		const productsRef = collection(db, getTenantCollectionPath('products'));
		const q = query(productsRef, where('brand.id', '==', id));
		const snapshot = await getDocs(q);

		if (!snapshot.empty) {
			snapshot.docs.forEach((productDoc) => {
				const updatedBrandData = {
					id: id,
					name: brandData.name,
					logo: brandData.logo || productDoc.data().brand?.logo || '',
				};

				transaction.update(productDoc.ref, {
					brand: updatedBrandData,
					updatedAt: new Date(),
				});
			});
		}
	});
}

export class BrandFunctions {
	static async updateBrand(id, brandData) {
		await updateBrandInProducts(id, brandData);
	}
}
